import React from 'react';

import { TableCell, TableHead, TableRow, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { useTranslation } from 'react-i18next';

const sxTableHead: SxProps<Theme> = { '& th': { fontWeight: 'bold', textAlign: 'center' } };

const StaffTravelListHead = React.memo(() => {
  const { t } = useTranslation();

  return (
    <TableHead className="sticky-header-multiline">
      <TableRow sx={sxTableHead}>
        <TableCell>{t(`general.previous_school`)}</TableCell>
        <TableCell>{t(`general.school`)}</TableCell>
        <TableCell>{t(`general.school_year`)}</TableCell>
        <TableCell>{t(`general.school_level`)}</TableCell>
        <TableCell>{t(`general.total`)}</TableCell>
      </TableRow>
    </TableHead>
  );
});

export default StaffTravelListHead;
